import React from 'react';

export default {
  path: '/content/space',
  async action() {
    const { default: ContentPartnerSpaceList } =
      await import('./ContentPartnerSpaceList');
    return <ContentPartnerSpaceList key={'list'} />;
  },
};
